import { tagsSlice } from "./tagsSlice";
import * as actions from "./tagsActions";
import * as selectors from "./tagsSelectors";

export { actions };
export { selectors };
export default tagsSlice.reducer;
